/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getDocumentFiles = /* GraphQL */ `
  query GetDocumentFiles($input: DocumentFileInput!) {
    getDocumentFiles(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const getDocumentFolder = /* GraphQL */ `
  query GetDocumentFolder($input: DocumentFolderInput!) {
    getDocumentFolder(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const putVaultPermissions = /* GraphQL */ `
  query PutVaultPermissions($input: PutVaultPermissionsInput!) {
    putVaultPermissions(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const getVaultPermissions = /* GraphQL */ `
  query GetVaultPermissions($input: VaultPermissionsInput!) {
    getVaultPermissions(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const getLLMModels = /* GraphQL */ `
  query GetLLMModels {
    getLLMModels {
      statusCode
      body
      __typename
    }
  }
`;
export const getCategories = /* GraphQL */ `
  query GetCategories {
    getCategories {
      statusCode
      body
      __typename
    }
  }
`;
export const putContactsFromList = /* GraphQL */ `
  query PutContactsFromList($input: PutContactsFromListInput) {
    putContactsFromList(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const getVehicleStockFilter = /* GraphQL */ `
  query GetVehicleStockFilter($input: GetVehicleStockFilterInput) {
    getVehicleStockFilter(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const putNotificationRead = /* GraphQL */ `
  query PutNotificationRead($input: PutReadNotificationInput!) {
    putNotificationRead(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const getNotification = /* GraphQL */ `
  query GetNotification($input: GetNotificationInput!) {
    getNotification(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const getImage = /* GraphQL */ `
  query GetImage($input: GetImageInput!) {
    getImage(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const putImage = /* GraphQL */ `
  query PutImage($input: PutImageInput!) {
    putImage(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const getCampaignRetryTemplate = /* GraphQL */ `
  query GetCampaignRetryTemplate($input: GetCampaignRetryTemplateInput!) {
    getCampaignRetryTemplate(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const getVehicleStockPictures = /* GraphQL */ `
  query GetVehicleStockPictures($input: GetVehiclesStockInput!) {
    getVehicleStockPictures(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const putGenerateAvatar = /* GraphQL */ `
  query PutGenerateAvatar($input: PutGenerateAvatar!) {
    putGenerateAvatar(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
// [DEPRECATED_GRAPHQL] - Para eliminación: getSingleContact y putSingleContact usados por ContactStore
// TODO: Eliminar después de verificar que nuevas APIs funcionan correctamente

// export const getSingleContact = /* GraphQL */ `
//   query GetSingleContact($input: GetSingleContactInput!) {
//     getSingleContact(input: $input) {
//       statusCode
//       body
//       __typename
//     }
//   }
// `;
// export const putSingleContact = /* GraphQL */ `
//   query PutSingleContact($input: PutSingleContact!) {
//     putSingleContact(input: $input) {
//       statusCode
//       body
//       __typename
//     }
//   }
// `;
export const deleteMarketingCampaign = /* GraphQL */ `
  query DeleteMarketingCampaign($input: DeleteMarketingCampaignInput!) {
    deleteMarketingCampaign(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const getUsers = /* GraphQL */ `
  query GetUsers($input: GetUserInput!) {
    getUsers(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const putUser = /* GraphQL */ `
  query PutUser($input: PutUserInput!) {
    putUser(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
// export const deleteUser = /* GraphQL */ `
//   query DeleteUser($input: DeleteUserInput!) {
//     deleteUser(input: $input) {
//       statusCode
//       body
//       __typename
//     }
//   }
// `;
// export const getAnnUsers = /* GraphQL */ `
//   query GetAnnUsers($input: GetAnnUsersInput!) {
//     getAnnUsers(input: $input) {
//       statusCode
//       body
//       __typename
//     }
//   }
// `;
// [DEPRECATED_GRAPHQL] - Para eliminación: getAnnUserContact usado por UnifiedCustomerProfile.fetchUCPData
// TODO: Eliminar después de verificar que nuevas APIs funcionan correctamente

// export const getAnnUserContact = /* GraphQL */ `
//   query GetAnnUserContact($input: GetAnnUserContactInput!) {
//     getAnnUserContact(input: $input) {
//       statusCode
//       body
//       __typename
//     }
//   }
// `;
// [DEPRECATED_GRAPHQL] - Para eliminación: No se está usando en el proyecto
// TODO: Eliminar después de verificar que no se necesita

// export const getChannels = /* GraphQL */ `
//   query GetChannels($input: getChannelInput!) {
//     getChannels(input: $input) {
//       statusCode
//       body
//       __typename
//     }
//   }
// `;
export const getKeys = /* GraphQL */ `
  query GetKeys($input: getKeyInput!) {
    getKeys(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const putKey = /* GraphQL */ `
  query PutKey($input: PutKeyInput!) {
    putKey(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const deleteKey = /* GraphQL */ `
  query DeleteKey($input: DeleteKeyInput!) {
    deleteKey(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const getCustomers = /* GraphQL */ `
  query GetCustomers($input: GetCustomerInput) {
    getCustomers(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const putCustomer = /* GraphQL */ `
  query PutCustomer($input: PutCustomerInput!) {
    putCustomer(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
// [DEPRECATED_GRAPHQL] - Para eliminación: No se está usando en el proyecto
// TODO: Eliminar después de verificar que no se necesita

// export const deleteChannel = /* GraphQL */ `
//   query DeleteChannel($input: DeleteChannelInput!) {
//     deleteChannel(input: $input) {
//       statusCode
//       body
//       __typename
//     }
//   }
// `;
export const getUploadUrlFile = /* GraphQL */ `
  query GetUploadUrlFile($input: PutFileInput!) {
    getUploadUrlFile(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const getUrlFile = /* GraphQL */ `
  query GetUrlFile($input: GetFileInput!) {
    getUrlFile(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const putCampaigns = /* GraphQL */ `
  query PutCampaigns($input: putCampaignsInput!) {
    putCampaigns(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const putCampaignMarketing = /* GraphQL */ `
  query PutCampaignMarketing($input: putCampaignMarketingInput!) {
    putCampaignMarketing(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const deleteCampaign = /* GraphQL */ `
  query DeleteCampaign($input: deleteCampignsInput!) {
    deleteCampaign(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const getCampaigns = /* GraphQL */ `
  query GetCampaigns($input: getCampignsInput!) {
    getCampaigns(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const getDefaultProjects = /* GraphQL */ `
  query GetDefaultProjects($input: getCampignsDefaultProjectsInput!) {
    getDefaultProjects(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const getContactFiles = /* GraphQL */ `
  query GetContactFiles($input: getContactFilesInput!) {
    getContactFiles(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const putAgent = /* GraphQL */ `
  query PutAgent($input: PutAgentInput!) {
    putAgent(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const getAgent = /* GraphQL */ `
  query GetAgent($input: GetAgentInput!) {
    getAgent(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const deleteAgent = /* GraphQL */ `
  query DeleteAgent($input: DeleteAgentInput!) {
    deleteAgent(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const getConversationChatAssistant = /* GraphQL */ `
  query GetConversationChatAssistant($input: AgentConversationInput!) {
    getConversationChatAssistant(input: $input) {
      id
      statusCode
      status
      body
      __typename
    }
  }
`;
// [DEPRECATED_GRAPHQL] - Para eliminación: No se está usando en el proyecto
// TODO: Eliminar después de verificar que no se necesita

// export const getCampaignJourneys = /* GraphQL */ `
//   query GetCampaignJourneys($input: GetJourneysInput!) {
//     getCampaignJourneys(input: $input) {
//       statusCode
//       body
//       __typename
//     }
//   }
// `;
// export const putCampaignJourneys = /* GraphQL */ `
//   query PutCampaignJourneys($input: PutJourneyInput!) {
//     putCampaignJourneys(input: $input) {
//       statusCode
//       body
//       __typename
//     }
//   }
// `;
export const putScrapping = /* GraphQL */ `
  query PutScrapping($input: PutScrappingInput!) {
    putScrapping(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const preDeleteAgent = /* GraphQL */ `
  query PreDeleteAgent($input: PreDeleteAgentInput!) {
    preDeleteAgent(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
// [DEPRECATED_GRAPHQL] - Para eliminación: No se está usando en el proyecto
// TODO: Eliminar después de verificar que no se necesita

// export const postDeleteAgent = /* GraphQL */ `
//   query PostDeleteAgent($input: PostDeleteAgentInput!) {
//     postDeleteAgent(input: $input) {
//       statusCode
//       body
//       __typename
//     }
//   }
// `;
export const deleteAgentFile = /* GraphQL */ `
  query DeleteAgentFile($input: DeleteAgentFileInput!) {
    deleteAgentFile(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
// [DEPRECATED_GRAPHQL] - Para eliminación: getContacts usado por UnifiedCustomerProfile.getUCP
// TODO: Eliminar después de verificar que nuevas APIs funcionan correctamente

// export const getContacts = /* GraphQL */ `
//   query GetContacts($input: getContactsInput!) {
//     getContacts(input: $input) {
//       statusCode
//       body
//       __typename
//     }
//   }
// `;
export const getContactsAnn = /* GraphQL */ `
  query GetContactsAnn($input: getContactsInput!) {
    getContactsAnn(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const getQuicksightEmbedUrl = /* GraphQL */ `
  query GetQuicksightEmbedUrl($input: getQuicksightEmbedUrlInput!) {
    getQuicksightEmbedUrl(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
// [DEPRECATED_GRAPHQL] - Para eliminación: No se está usando en el proyecto
// TODO: Eliminar después de verificar que no se necesita

// export const getMessages = /* GraphQL */ `
//   query GetMessages($input: GetMessagesInput!) {
//     getMessages(input: $input) {
//       statusCode
//       body
//       __typename
//     }
//   }
// `;
export const getConversationsHistory = /* GraphQL */ `
  query GetConversationsHistory($input: GetConversationsHistory!) {
    getConversationsHistory(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
// [DEPRECATED_GRAPHQL] - Para eliminación: No se está usando en el proyecto
// TODO: Eliminar después de verificar que no se necesita

// export const createAgentTeam = /* GraphQL */ `
//   query CreateAgentTeam($input: PutAgentTeamInput!) {
//     createAgentTeam(input: $input) {
//       statusCode
//       body
//       __typename
//     }
//   }
// `;
// export const updateAgentTeam = /* GraphQL */ `
//   query UpdateAgentTeam($input: PutAgentTeamInput!) {
//     updateAgentTeam(input: $input) {
//       statusCode
//       body
//       __typename
//     }
//   }
// `;
export const getPermissionCatalogUser = /* GraphQL */ `
  query GetPermissionCatalogUser($input: GetUserPermissionsInput!) {
    getPermissionCatalogUser(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
// export const getUserPermissions = /* GraphQL */ `
//   query GetUserPermissions($input: GetUserPermissionsInput!) {
//     getUserPermissions(input: $input) {
//       statusCode
//       body
//       __typename
//     }
//   }
// `;
// export const getRoles = /* GraphQL */ `
//   query GetRoles($input: GetRolesInput!) {
//     getRoles(input: $input) {
//       statusCode
//       body
//       __typename
//     }
//   }
// `;
// export const getRolePermissions = /* GraphQL */ `
//   query GetRolePermissions($input: GetRolePermissionsInput!) {
//     getRolePermissions(input: $input) {
//       statusCode
//       body
//       __typename
//     }
//   }
// `;
// export const putRole = /* GraphQL */ `
//   query PutRole($input: PutRoleInput!) {
//     putRole(input: $input) {
//       statusCode
//       body
//       __typename
//     }
//   }
// `;
// export const putUserPermissions = /* GraphQL */ `
//   query PutUserPermissions($input: PutUserPermissionsInput!) {
//     putUserPermissions(input: $input) {
//       statusCode
//       body
//       __typename
//     }
//   }
// `;
// export const putPermissionsRole = /* GraphQL */ `
//   query PutPermissionsRole($input: PutPermissionsRoleInput!) {
//     putPermissionsRole(input: $input) {
//       statusCode
//       body
//       __typename
//     }
//   }
// `;
// export const putUserRole = /* GraphQL */ `
//   query PutUserRole($input: PutUserRoleInput!) {
//     putUserRole(input: $input) {
//       statusCode
//       body
//       __typename
//     }
//   }
// `;
// export const getTrigger = /* GraphQL */ `
//   query GetTrigger($input: getTriggersInput!) {
//     getTrigger(input: $input) {
//       statusCode
//       body
//       __typename
//     }
//   }
// `;
// export const putTrigger = /* GraphQL */ `
//   query PutTrigger($input: putTriggerInput!) {
//     putTrigger(input: $input) {
//       statusCode
//       body
//       __typename
//     }
//   }
// `;
export const getEvent = /* GraphQL */ `
  query GetEvent($input: GetEventInput!) {
    getEvent(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const getAction = /* GraphQL */ `
  query GetAction($input: getActionsInput!) {
    getAction(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
// [DEPRECATED_GRAPHQL] - Para eliminación: No se está usando en el proyecto
// TODO: Eliminar después de verificar que no se necesita

// export const getUCPData = /* GraphQL */ `
//   query GetUCPData($input: GetUCPDataInput!) {
//     getUCPData(input: $input) {
//       statusCode
//       body
//       __typename
//     }
//   }
// `;
export const putEmailBlast = /* GraphQL */ `
  query PutEmailBlast($input: PutEmailBlastInput!) {
    putEmailBlast(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const getContactsSegment = /* GraphQL */ `
  query GetContactsSegment($input: GetContactsSegmentInput!) {
    getContactsSegment(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
// [DEPRECATED_GRAPHQL] - Para eliminación: AlertPage y dependencias usan GraphQL queries
// TODO: Eliminar después de verificar que nuevas APIs funcionan correctamente

// export const getAlert = /* GraphQL */ `
//   query GetAlert($input: GetAlertInput!) {
//     getAlert(input: $input) {
//       statusCode
//       body
//       __typename
//     }
//   }
// `;
// export const putAlert = /* GraphQL */ `
//   query PutAlert($input: PutAlertInput!) {
//     putAlert(input: $input) {
//       statusCode
//       body
//       __typename
//     }
//   }
// `;
export const cancelRun = /* GraphQL */ `
  query CancelRun($input: cancelRunInput) {
    cancelRun(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const putUserResources = /* GraphQL */ `
  query PutUserResources($input: PutUserResourcesInput!) {
    putUserResources(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const getResources = /* GraphQL */ `
  query GetResources($input: GetResourcesInput!) {
    getResources(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
// [DEPRECATED_GRAPHQL] - Para eliminación: getVehicleVinPictures usado por UnifiedCustomerProfile.fetchVehicleVinPictures
// TODO: Eliminar después de verificar que nuevas APIs funcionan correctamente

// export const getVehicleVinPictures = /* GraphQL */ `
//   query GetVehicleVinPictures($input: GetVehicleVinPicturesInput!) {
//     getVehicleVinPictures(input: $input) {
//       statusCode
//       body
//       __typename
//     }
//   }
// `;
export const getVehicleStockImages = /* GraphQL */ `
  query GetVehicleStockImages($input: GetVehicleStockImagesInput!) {
    getVehicleStockImages(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const getLogs = /* GraphQL */ `
  query GetLogs($input: GetLogsInput!) {
    getLogs(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
// [DEPRECATED_GRAPHQL] - Para eliminación: getData usado por DataStore, ContactStore y UnifiedCustomerProfile
// TODO: Eliminar después de verificar que nuevas APIs funcionan correctamente

// export const getData = /* GraphQL */ `
//   query GetData($input: getDataInput!) {
//     getData(input: $input) {
//       statusCode
//       body
//       __typename
//     }
//   }
// `;
export const getInterview = /* GraphQL */ `
  query GetInterview($input: GetInterviewInput!) {
    getInterview(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const putInterview = /* GraphQL */ `
  query PutInterview($input: PutInterviewInput!) {
    putInterview(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const delInterview = /* GraphQL */ `
  query DelInterview($input: DeleteInterviewInput!) {
    delInterview(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const getInvokePersona = /* GraphQL */ `
  query GetInvokePersona($input: GetInvokePersonaInput!) {
    getInvokePersona(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const getInvokeInterview = /* GraphQL */ `
  query GetInvokeInterview($input: GetInvokeInterviewInput!) {
    getInvokeInterview(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const getNotes = /* GraphQL */ `
  query GetNotes($input: GetNotesInput!) {
    getNotes(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const putNotes = /* GraphQL */ `
  query PutNotes($input: PutNotesInput!) {
    putNotes(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const getCustomerMessages = /* GraphQL */ `
  query GetCustomerMessages($input: GetCustomerMessagesInput!) {
    getCustomerMessages(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
// export const getGroups = /* GraphQL */ `
//   query GetGroups($input: GetGroupsInput!) {
//     getGroups(input: $input) {
//       statusCode
//       body
//       __typename
//     }
//   }
// `;
export const getCampaignMessages = /* GraphQL */ `
  query GetCampaignMessages($campaign: String) {
    getCampaignMessages(campaign: $campaign) {
      statusCode
      body
      __typename
    }
  }
`;
export const putCampaignMessage = /* GraphQL */ `
  query PutCampaignMessage(
    $message_id: String
    $campaign_id: String
    $updated_message: String
  ) {
    putCampaignMessage(
      message_id: $message_id
      campaign_id: $campaign_id
      updated_message: $updated_message
    ) {
      statusCode
      body
      __typename
    }
  }
`;
export const putPrompt = /* GraphQL */ `
  query PutPrompt($input: PutPromptInput!) {
    putPrompt(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const getPrompt = /* GraphQL */ `
  query GetPrompt($input: GetPromptInput!) {
    getPrompt(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const deletePrompt = /* GraphQL */ `
  query DeletePrompt($input: DeletePromptInput!) {
    deletePrompt(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
// export const getSettings = /* GraphQL */ `
//   query GetSettings($input: GetSettingsInput!) {
//     getSettings(input: $input) {
//       statusCode
//       body
//       __typename
//     }
//   }
// `;
export const putDocumentFileUpload = /* GraphQL */ `
  query PutDocumentFileUpload($input: DocumentFileUploadInput!) {
    putDocumentFileUpload(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
// [DEPRECATED_GRAPHQL] - Para eliminación: No se está usando en el proyecto
// TODO: Eliminar después de verificar que no se necesita

// export const deleteDocumentFiles = /* GraphQL */ `
//   query DeleteDocumentFiles($input: DocumentFileDeleteInput!) {
//     deleteDocumentFiles(input: $input) {
//       statusCode
//       body
//       __typename
//     }
//   }
// `;
export const putDocumentFolder = /* GraphQL */ `
  query PutDocumentFolder($input: DocumentFolderPutInput!) {
    putDocumentFolder(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
// [DEPRECATED_GRAPHQL] - Para eliminación: No se está usando en el proyecto
// TODO: Eliminar después de verificar que no se necesita

// export const deleteDocumentFolder = /* GraphQL */ `
//   query DeleteDocumentFolder($input: DocumentFolderDeleteInput!) {
//     deleteDocumentFolder(input: $input) {
//       statusCode
//       body
//       __typename
//     }
//   }
// `;
export const getConversationChatPublicAssistant = /* GraphQL */ `
  query GetConversationChatPublicAssistant(
    $input: AgentPublicConversationInput!
  ) {
    getConversationChatPublicAssistant(input: $input) {
      body
      statusCode
      __typename
    }
  }
`;
